import { useState } from 'react';

const useLoginFormInitialValue = () => {
  const [initialValue] = useState(() => ({
    rememberMe: !!localStorage.getItem('remember_me'),
  }));

  return { initialValue };
};

export default useLoginFormInitialValue;
